import axios from 'axios';
import { Cookies } from 'react-cookie';
import { attachApiErrorToastInterceptor } from '../../utils/api-error-toast';

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_CART_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});
attachApiErrorToastInterceptor(axiosInstance);

axiosInstance.interceptors.request.use((config) => {
  const cookies = new Cookies();
  const token = cookies.get('session_token');
  config.headers.Authorization = `Bearer ${token}`;
  return config;
});

type cartCheckoutArg = {
  name: string;
  contactType: string | undefined;
  userEmail: string | undefined;
  userPhone: string | undefined;
  pay_with_cash?: boolean;
};
// | {
//     name: string;
//     contactType: 'phone';
//     userPhone: string | undefined;
//   };

export const cartCheckout = async (arg: cartCheckoutArg) => {
  if (process.env.REACT_APP_API_BASE_CART_URL) {
    let objectToSend: any = {};

    if (arg.contactType === 'email') {
      objectToSend = {
        name: arg.name,
        email: arg.userEmail,
        pay_with_cash: arg.pay_with_cash,
      };
    } else {
      objectToSend = {
        name: arg.name,
        phone_number: arg.userPhone,
        pay_with_cash: arg.pay_with_cash,
      };
    }

    const response = await axiosInstance.post('checkout', objectToSend);
    return response.data;
  }
};

type updateNoteOrCouponCodeArg =
  | {
      type: 'note';
      note: string;
    }
  | {
      type: 'coupon-code';
      couponCode: string;
    };

export const updateNoteOrCouponCode = async (arg: updateNoteOrCouponCodeArg) => {
  let objectToSend: any = {};

  if (arg.type === 'note') {
    objectToSend.note = arg.note;
  } else {
    objectToSend.coupon_code = arg.couponCode;
  }

  const response = await axiosInstance.patch('', objectToSend);
  return response.data;
};
